import styled from "styled-components";

const ZoomStyleDiv = styled.div`
  display: flex;
  flex-direction: column;
  left: 15px;
  position: absolute;
  top: 15px;
  z-index: 1;
`;

const ButtonStyle = styled.button`
  background-color: white;
  border: 1px solid rgba(0, 0, 0, 1);
  display: inline-block;
  font: normal normal normal 14px/1 FontAwesome;
  height: 25px;
  padding: 0;
  width: 25px;

  &:focus {
    outline: none;
  }
`;

const TopButtonStyle = styled(ButtonStyle)`
  border-radius: 4px 4px 0 0;
  border-style: solid solid none;
`;

const BottomButtonStyle = styled(ButtonStyle)`
  border-radius: 0 0 4px 4px;
`;

ZoomStyleDiv.displayName = "ZoomStyleDiv";
ButtonStyle.displayName = "ButtonStyle";
TopButtonStyle.displayName = "TopButtonStyle";
BottomButtonStyle.displayName = "TopButtonStyle";

export { ZoomStyleDiv, BottomButtonStyle, TopButtonStyle };
